import React from 'react';
import {  withApollo } from 'react-apollo';

import Passenger from './Passenger';
import { DetachClaimsPassengerTicket } from '../../../../mutations/DetachClaimsPassengerTicket';

const Passengers = ({
  passengers,
  onClaimUpdated,
  hideLoading,
  showLoading,
  client,
  passengerTicketId,
  errors,
  touched,
  id,
  setFieldValue,
  ...rest
}) => {
  const handleRemovePassenger = passengerId => {
    if (!passengerId) return;
    showLoading();
    client
      .mutate({
        mutation: DetachClaimsPassengerTicket,
        variables: {
          input: {
            passengerTicketId: passengerId,
            claimId: id
          }
        }
      })
      .then(() => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(() => hideLoading());
  };

  const handlePassengerChange = (id, e, { name, value }) => {
    setFieldValue('passengers', passengers.map(
      p => (p.id === id ? { ...p, [name]: value } : p)
    ));
  };

  return passengers.map((passenger, index) => {
    const passengersErrors = errors ? errors.passengers : {};
    const passengersTouched = touched ? touched.passengers : {};
    return (
      <Passenger
        key={passenger.id}
        passenger={passenger}
        index={index}
        errors={passengersErrors ? passengersErrors[index] : undefined}
        touched={passengersTouched ? passengersTouched[index] : undefined}
        onPassengerChange={handlePassengerChange}
        onRemovePassenger={handleRemovePassenger}
        removable={passengerTicketId !== passenger.id}
        {...rest}
      />
    );
  });
};

export default withApollo(Passengers);



// WEBPACK FOOTER //
// ./src/component/ClaimForm/Form/Passengers/index.js